
<div class="container">
	<div class="base-container">
		<!-- Left container-->
		<aside class="left-container">
			<access></access>
		</aside>

		<div class="main-container">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>
